import store from '@store/appStore';
import { ROOT_STATE } from '@store/store.types';
import type { ISSOConfig } from '@utils/types/environment';

// Get SSO config from environment api
export const getSSOConfig = (): ISSOConfig => {
    const state: ROOT_STATE = store.getState();
    const ssoConfig = state.common.environment.ssoConfig;

    return ssoConfig;
};

export default {
    getSSOConfig
};
